<template>
  <div class="roleAdmin">
    <div class="menuCont">
      <my-tree ref='myTree'
               :treeData='treeData'
               :treeLoading='treeLoading'
               :treeToolBar='treeToolBar'
               :defaultProps='defaultProps'
               :departTotal='departTotal'
               :nodeKey="'id'"
               @handleAddTreeNode='handleAddTreeNode'
               @handleTreeNodeClick='handleTreeNodeClick'
               :default-expand-all="true"
               :btnName="btnName"
               :treeSearchBar="true"
               @searchChange="searchChange">
      </my-tree>

    </div>
    <div class="formCont">
      <el-form :model="addForm"
               ref="addForm"
               label-width="100px"
               :inline="true">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="角色名称"
                          :rules="[{required: true, message: '请输入部门名称'}]"
                          prop="name">
              <el-input clearable
                        placeholder="请输入角色名称"
                        maxlength="20"
                        size="small"
                        v-model="addForm.name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注描述">
              <el-input clearable
                        placeholder="请输入备注描述"
                        maxlength="20"
                        size="small"
                        v-model="addForm.remark">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="角色类型"
                          :rules="[{required: true, message: '请选择角色类型'}]"
                          prop="type">
              <el-select v-model="addForm.type"
                         placeholder="请选择角色类型"
                         size="small">
                <el-option v-for="item in typeList"
                           :key="item.key"
                           :label="item.value"
                           :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模块权限">
              <el-tree ref="treeRow"
                       :treeLoading='treeLoading'
                       :data="rowTreeData"
                       show-checkbox
                       :render-content="renderContent"
                       :highlight-current="true"
                       node-key="id"
                       :props="rowTreeProps"
                       default-expand-all
                       :filter-node-method="filterNode"
                       :expand-on-click-node="false"
                       @check="handleCheckChange"
                       :default-checked-keys="addForm.authority"
                       style="font-size:12px">

              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:left;margin:80px 0 0 100px;">
        <el-button @click="commit"
                   type="primary"
                   size="small">保 存</el-button>
        <el-button @click="clear"
                   v-if="nowStatus"
                   size="small">清 空</el-button>
        <el-button @click="del"
                   type="danger"
                   v-else
                   size="small">删 除</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import Tree from "@/comon/components/treeChange";
import { mapState } from "vuex";
export default {
    data() {
        return {
            treeData: [],
            treeLoading: false,
            treeToolBar: true,
            defaultProps: {
                children: "child",
                label: "name",
            },
            rowTreeProps: {
                children: "child",
                label: "name",
            },
            btnName: "创建角色",

            addForm: {
                type: "",
            },
            nowStatus: 0,
            nowClick: "",

            typeList: [
                { key: "admin", value: "超级管理员" },
                { key: "subadmin", value: "经理" },
                { key: "leader", value: "组长" },
                { key: "staff", value: "普通员工" },
            ],
        };
    },
    components: {
        "my-tree": Tree,
    },
    methods: {
        getRoleList(name, id) {
            this.treeLoading = true;
            oaApi.role(name ? { name: name } : {}, "get", id).then((res) => {
                if (res) {
                    if (id) {
                        this.addForm = res.data;
                        this.$nextTick(() => {
                            this.$refs.treeRow.setCheckedKeys(
                                this.addForm.authority
                            );
                        });
                    } else {
                        this.treeData = res.data;
                        this.getRoleList(
                            "",
                            this.addForm.id ? this.addForm.id : res.data[0].id
                        );
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id
                                    ? this.addForm.id
                                    : res.data[0].id
                            );
                        });
                    }
                    this.treeLoading = false;
                }
            });
        },
        handleAddTreeNode(sth) {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm = {
                authority: [],
                id: "",
                name: "",
                remark: "",
                type: "",
            };
            this.nowStatus = 1;
            this.nowClick = null;
            this.$nextTick(() => {
                this.$refs.myTree.$refs.tree.setCurrentKey();
                this.$refs.treeRow.setCheckedKeys(this.addForm.authority);
            });
        },
        searchChange(text) {
            this.getRoleList(text);
        },
        handleTreeNodeClick(item) {
            this.treeLoading = true;
            this.getRoleList("", item.id);
            this.nowStatus = 0;
            this.nowClick = item.id;
            this.$nextTick(() => {
                this.$refs.treeRow.setCheckedKeys(this.addForm.authority);
            });
            this.treeLoading = false;
        },
        getMenu() {
            oaApi.menu({}, "get").then((res) => {
                if (res) {
                    this.rowTreeData = res.data[0].child;
                }
            });
        },
        clear() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm = {
                authority: [],
                id: "",
                name: "",
                remark: "",
                type: "",
            };
        },
        del() {
            this.treeLoading = true;
            this.$confirm("确认删除该角色？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    oaApi.role({}, "delete", this.nowClick).then((res) => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success("删除成功");
                            }
                            this.clear();
                            this.getRoleList();
                        }
                    });
                })
                .catch(() => {
                    this.$message.info("未删除");
                });
        },
        //修改节点Dom
        renderContent(h, { node, data, store }) {
            let className = "";
            // perms这个是后台数据区分普通tree节点和横向tree节点的标志  各位要根据实际情况做相对应的修改
            if (node.level == 3) {
                className = "especially";
            }
            return (
                // 在需要做横向排列的模块做标记
                <div class={className}>{data.name}</div>
            );
        },
        handleCheckChange(item) {
            let arr1 = this.$refs.treeRow.getHalfCheckedKeys();
            let arr2 = this.$refs.treeRow.getCheckedKeys();
            let arr = arr1.concat(arr2);
            this.authority = arr;
        },
        // 改变tree节点样式
        changeTreeClass() {
            // 找到之前做标记的class
            var classDomList = document.getElementsByClassName("especially");

            //   改变这几个样式
            for (var i = 0; i < classDomList.length; i++) {
                classDomList[i].parentNode.style.cssText = "float: left";
                classDomList[i].parentNode.className =
                    "el-tree-node__content option-wrapper";
                classDomList[
                    i
                ].parentNode.parentNode.parentNode.style.marginLeft = "70px";
            }
        },
        // 保存提交
        commit() {
            this.handleCheckChange();
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    oaApi
                        .role(
                            {
                                id: this.addForm.id ? this.addForm.id : "",
                                name: this.addForm.name,
                                authority: this.authority,
                                remark: this.addForm.remark,
                                type: this.addForm.type,
                            },
                            this.addForm.id ? "put" : "post",
                            this.addForm.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success("保存成功");
                                this.getRoleList();
                            }
                        });
                }
            });
        },
    },
    created() {
        this.getRoleList();
        this.getMenu();
    },
    updated() {
        this.changeTreeClass();
    },
};
</script>
<style lang="scss">
.roleAdmin {
    width: 100%;
    min-height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        // border-right: 1px #eee solid;
        // padding: 0 20px;
        box-sizing: border-box;
        height: 100%;
    }
    .formCont {
        width: calc(100% - 250px);
        padding: 20px;
        border-left: 1px #ddd solid;
        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content {
            width: 700px;
        }
        .el-input {
            width: 500px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
    }
    .option-wrapper {
        padding: 0 !important;
    }
}
</style>